/**
 * Created by zzy on 2019/8/5.
 */
import LoginLogs from './LoginLogs.vue'
export default LoginLogs



// WEBPACK FOOTER //
// ./src/views/events/LoginLogs/index.js